import { widgetsConfig } from "components/Widgets/Sidekick";
import { customAudit } from "./auditActions";
import { websocketMessage } from "./userActions";

export const ADD_WIDGET = "ADD_WIDGET";
export const REMOVE_WIDGET = "REMOVE_WIDGET";
export const CHANGE_WIDGET_STATUS = "CHANGE_WIDGET_STATUS";

export const focusWidget = (widget) => window.open("", widget).focus();

export const addWidget = (widget) => {
    return {
        type: ADD_WIDGET,
        widget,
    };
};

export const removeWidget = (widgetType, id) => {
    return {
        type: REMOVE_WIDGET,
        widgetType,
        id,
    };
};

export const changeWidgetStatus = (widget, status) => {
    return {
        type: CHANGE_WIDGET_STATUS,
        widget,
        status,
    };
};

export const openWidget = (widgetType, { features = "width=600,height=400,left=200,top=200", queryString = "" } = {}) => {
    return (dispatch, getState) => {
        const state = getState();
        const existingWidgets = state.widgets[widgetType] || {};
        const existingWidgetIds = Object.keys(existingWidgets);

        if (existingWidgetIds.length < widgetsConfig[widgetType].limit) {
            const id = Math.max(0, ...existingWidgetIds) + 1;

            dispatch(customAudit("widget_opened", { widgetType }, `${widgetType} widget opened`));
            dispatch(addWidget({ type: widgetType, id }));

            const wsToken = state.userDetails.userConfig.ws_token;

            let url = `/widget/${widgetType}/${wsToken}?id=${id}`;
            if (queryString) {
                url += `&${queryString}`;
            }

            window.open(url, `${widgetType}-${id}`, features);
        } else if (existingWidgetIds.length) {
            existingWidgetIds.forEach((id) => {
                focusWidget(`${widgetType}-${id}`);
            });
        }
    };
};

export const closeWidget = (widgetType) => {
    return (dispatch, getState) => {
        const existingWidgets = getState().widgets[widgetType] || {};
        const existingWidgetIds = Object.keys(existingWidgets);

        dispatch(removeWidget(widgetType));
        existingWidgetIds.forEach((id) => {
            dispatch(websocketMessage({ msg: "CLOSE" }, { type: widgetType, id }));
        });
    };
};
